import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, NavLink } from "react-router-dom";
import Logo from "./assets/images/Logo.png";
import FacebookLogo from "./assets/images/icons/facebook.png";
import TwitterLogo from "./assets/images/icons/twitter.png";
import InstagramLogo from "./assets/images/icons/instagram.png";
import LinkedInLogo from "./assets/images/icons/linkedin.png";
import YouTubeLogo from "./assets/images/icons/youtube.png";

const NavBar = () => {
  return (
    <Navbar bg="transparent" variant="dark" expand="lg" collapseOnSelect={true}>
      <Container>
        <Link to="/" className="me-3">
          <img
            id="nav-logo"
            src={Logo}
            alt="Ahmed Ishmael Logo"
            height="60px"
          />
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/" href="/" end className=" p-3">
              HOME
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about" href="/about" className="p-3">
              ABOUT
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/portfolio"
              href="/portfolio"
              className="p-3"
            >
              PORTFOLIO
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/services"
              href="/services"
              className="p-3"
            >
              SERVICES
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/contact"
              href="/contact"
              className="p-3"
            >
              CONTACT
            </Nav.Link>
          </Nav>
          <Nav id="social-media" className="ms-auto">
            <Nav.Link
              href="https://www.facebook.com/ahmedmishmael"
              target="_blank"
              rel="noreferrer"
              className=" py-3 px-2"
            >
              <img src={FacebookLogo} alt="Facebook Logo" />
            </Nav.Link>
            <Nav.Link
              href="https://twitter.com/ahmedmishmael"
              target="_blank"
              rel="noreferrer"
              className="py-3 px-2"
            >
              <img src={TwitterLogo} alt="Twitter Logo" />
            </Nav.Link>
            <Nav.Link
              href="https://instagram.com/ahmedmishmael"
              target="_blank"
              rel="noreferrer"
              className="py-3 px-2"
            >
              <img src={InstagramLogo} alt="Instagram Logo" />
            </Nav.Link>
            <Nav.Link
              href="https://www.linkedin.com/in/ahmedmishmael"
              target="_blank"
              rel="noreferrer"
              className="py-3 px-2"
            >
              <img src={LinkedInLogo} alt="LinkedIn Logo" />
            </Nav.Link>
            <Nav.Link
              href="https://www.youtube.com/@ahmedmishmael"
              target="_blank"
              rel="noreferrer"
              className="py-3 px-2"
            >
              <img src={YouTubeLogo} alt="YouTube Logo" />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
